import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import packageJson from "package.alias.json";
import { Colors } from "design-system";
import { StUserSpan } from "core/app/presenter/sideNav/SideNavStyles";

// flex-grow: 1 is intentional — pins the version block to the bottom of the nav
const StVersionNumber = styled("div")`
  width: 100%;
  color: ${Colors.White} !important;
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  align-items: baseline;
  cursor: default;
  padding: 0 18px;

  &:hover {
    background: none;
  }
`;

const VersionNumber = ({ pkg = packageJson }) => (
  <StVersionNumber>
    <StUserSpan>{`Version: ${pkg.version ?? "--"}`}</StUserSpan>
    <StUserSpan>{`Commit: ${pkg.commit?.substring(0, 7) ?? "--"}`}</StUserSpan>
  </StVersionNumber>
);

VersionNumber.propTypes = {
  pkg: PropTypes.shape({
    version: PropTypes.string,
    commit: PropTypes.string,
  }),
};

export default VersionNumber;
